import { all } from 'redux-saga/effects';
import watchAllOrderBooks from './order_book_saga';
import watchAllOrderTransactions from './order_transaction_saga';
import watchAllOrders from './order_saga';
import watchAllUsers from './user_saga';
import watchAllPrices from './price_saga';
import watchAllLogin from './login_saga';
import watchAllTransaction from './transaction_saga';
import watchAllWhiteList from './white_list_saga';
import watchAllNotify from './notify_saga';
import watchInit from './init_saga';
import watchCommission from './commission_saga';
import watchAllCampaign from './campaign_saga';
import watchAllFavorites from './favorites_saga';
import watchNotifications from './notifications_saga';

export default function* rootSaga() {
  yield all([
    watchAllOrderBooks(),
    watchAllOrderTransactions(),
    watchAllOrders(),
    watchAllUsers(),
    watchAllPrices(),
    watchAllLogin(),
    watchAllTransaction(),
    watchInit(),
    watchAllWhiteList(),
    watchAllNotify(),
    watchCommission(),
    watchAllCampaign(),
    watchAllFavorites(),
    watchNotifications(),
  ]);
}
